module.exports = function (e) {
    var t = {};

    function r(n) {
        if (t[n]) return t[n].exports;
        var a = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
        })
    }, r.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }, r.t = function (e, t) {
        if (1 & t && (e = r(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e)
            for (var a in e) r.d(n, a, function (t) {
                return e[t]
            }.bind(null, a));
        return n
    }, r.n = function (e) {
        var t = e && e.__esModule ? function () {
            return e.default
        } : function () {
            return e
        };
        return r.d(t, "a", t), t
    }, r.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, r.p = "", r(r.s = 0)
}([function (e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function (e, t) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return function (e, t) {
                var r = [],
                    n = !0,
                    a = !1,
                    u = void 0;
                try {
                    for (var o, l = e[Symbol.iterator](); !(n = (o = l.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0);
                } catch (e) {
                    a = !0, u = e
                } finally {
                    try {
                        !n && l.return && l.return()
                    } finally {
                        if (a) throw u
                    }
                }
                return r
            }(e, t);
            throw new TypeError("Invalid attempt to destructure non-iterable instance")
        },
        a = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        };
    t.Parser = s, t.Editor = function (e) {
        var t = (0, o.useState)(""),
            r = n(t, 2),
            u = r[0],
            i = r[1],
            f = (0, o.useRef)(""),
            p = (0, o.useState)(),
            g = n(p, 2),
            d = g[0],
            h = g[1];
        (0, o.useEffect)((function () {
            if (d) {
                var e = d.start,
                    t = d.end;
                f.current.focus(), f.current.setSelectionRange(e, t)
            }
        }), [d]);
        var b = e.buttons ? e.buttons : c;
        return l.default.createElement("div", e.container, l.default.createElement("div", e.buttonContainer, b.map((function (t, r) {
            return l.default.createElement("span", a({}, e.button, {
                key: r,
                onClick: function () {
                    ! function (t) {
                        var r = f.current.selectionStart,
                            n = f.current.selectionEnd,
                            a = t.tag;
                        if ("function" == typeof t.onClick) {
                            var o = t.onClick();
                            o && (a += "=" + o)
                        }
                        var l = "[" + a + "]",
                            c = "[/" + t.tag + "]",
                            s = u.substr(0, r) + l + u.substr(r, n - r) + c + u.substr(n);
                        i(s), h({
                            start: r + l.length,
                            end: n + l.length
                        }), "function" == typeof e.onChange && e.onChange(s)
                    }(t)
                },
                dangerouslySetInnerHTML: {
                    __html: t.caption
                }
            }))
        }))), l.default.createElement("textarea", a({}, e.textarea, {
            onChange: function (t) {
                h(null), i(t.currentTarget.value), "function" == typeof e.onChange && e.onChange(t.currentTarget.value)
            },
            ref: f,
            value: u
        })), e.preview ? l.default.createElement(s, {
            bbcode: u
        }) : null)
    }, t.parseBBCode = _;
    var u, o = r(1),
        l = (u = o) && u.__esModule ? u : {
            default: u
        };
    var i, c = [{
        caption: "<b>B</b>",
        tag: "b"
    }, {
        caption: "<i>I</i>",
        tag: "i"
    }, {
        caption: "<u>U</u>",
        tag: "u"
    }];

    function s(e) {
        return l.default.createElement("div", a({}, e, {
            dangerouslySetInnerHTML: {
                __html: _(e.bbcode.replaceAll("<", "&lt;").replaceAll(">", "&gt;"))
            }
        }))
    }
    var f = !0,
        p = !1,
        g = -1,
        d = /^\/?(?:b|center|i|u|pre|youtube|reklama|iframe|samp|code|colou?r|size|noparse|url|img|s|q|blockquote)$/, 
        h = /^(:?black|silver|gray|white|maroon|red|purple|fuchsia|green|lime|olive|yellow|navy|blue|teal|aqua|#(?:[0-9a-f]{3})?[0-9a-f]{3})$/i,
        b = /^[\\.0-9]{1,8}$/i,
        y = /^[-;\/\?:@&=\+\$,_\.!~\*'\(\)%0-9a-z]{1,512}$/i,
        v = /([\r\n])|(?:\[([a-z]{1,16})(?:=([^\x00-\x1F"'\(\)<>\[\]]{1,256}))?\])|(?:\[\/([a-z]{1,16})\])/gi;

    function m(e, t) {
        this.bbtag = e, this.etag = t
    }

    function w(e) {
        return !(!e || !e.length) && d.test(e)
    }

    function x(e, t, r, n, a, u, o) {
        if (t && t.length) {
            if (!f) return e;
            switch (t) {
                case "\r":
                    return "";
                case "\n":
                    return "<br>"
            }
        }
        if (w(r)) {
            if (p) return "[" + r + "]";
            if (i.length && "url" == i[i.length - 1].bbtag && g >= 0) return "[" + r + "]";
            switch (r) {
                case "code":
                    return i.push(new m(r, "</code></pre>")), f = !1, "<pre><code>";
                case "pre":
                    return i.push(new m(r, "</pre>")), f = !1, "<pre>";
                case "color":
                case "colour":
                    return n && h.test(n) || (n = "inherit"), i.push(new m(r, "</span>")), '<span style="color: ' + n + '">';
                case "size":
                    return n && b.test(n) || (n = "1"), i.push(new m(r, "</span>")), '<span style="font-size: ' + Math.min(Math.max(n, .7), 3) + 'em">';
                case "s":
                    return i.push(new m(r, "</span>")), '<span style="text-decoration: line-through">';
                case "noparse":
                    return p = !0, "";
                case "reklama":
                    return i.push(new m(r, "")), n && y.test(n) ? (g = -1, '<center><ins class="adsbygoogle"  style="display:inline-block;width:336px;height:280px"    data-ad-client="ca-pub-2691069495400373"    data-ad-slot="1455265245"></ins></center>') : (g = e.length + u, '<center><ins class="adsbygoogle"  style="display:inline-block;width:336px;height:280px"    data-ad-client="ca-pub-2691069495400373"    data-ad-slot="1455265245"></ins></center>');
                case "url":
                    return i.push(new m(r, "</a>")), n && y.test(n) ? (g = -1, '<a href="' + n + '">') : (g = e.length + u, '<a href="');
                case "youtube":
                    i.push(new m(r, '" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> </div> '));
                    return "<div class=\"videoWrapper\"><iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/";
                case "iframe":
                        i.push(new m(r, '" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> </div> '));
                        return "<div class=\"videoWrapper\"><iframe width=\"560\" height=\"315\" src=\"";
    


                    // <iframe src="" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>
                case "img":
                    i.push(new m(r, '">'));
                    var l = 'style="max-width: 100%;"';
                    if (n) switch (n) {
                        case "left":
                            l = 'style="max-width: 100%; float: left; padding: 4px 4px 4px 0px;"';
                            break;
                        case "right":
                            l = 'style="max-width: 100%; float: right; padding: 4px 0px 4px 4px;"';
                            break;
                        case "stretch":
                            l = 'style="width: 100%;"'
                    }
                    return "<img " + l + ' src="';
                case "q":
                case "blockquote":
                    return i.push(new m(r, "</" + r + ">")), n && n.length && y.test(n) ? "<" + r + ' cite="' + n + '">' : "<" + r + ">";
                default:
                    return i.push(new m(r, "</" + r + ">")), "<" + r + ">"
            }
        }
        return w(a) ? p ? "noparse" == a ? (p = !1, "") : "[/" + a + "]" : i.length && i[i.length - 1].bbtag == a ? "url" == a ? g > 0 ? '">' + o.substr(g, u - g) + i.pop().etag : i.pop().etag : ("code" != a && "pre" != a || (f = !0), i.pop().etag) : '<span style="color: red">[/' + a + "]</span>" : e
    }

    function _(e) {
        var t, r;
        if (f = !0, (null == i || i.length) && (i = new Array(0)), t = e.replace(v, x), p && (p = !1), i.length)
            for (r = new String, "url" == i[i.length - 1].bbtag && (i.pop(), r += '">' + e.substr(g, e.length - g) + "</a>"); i.length;) r += i.pop().etag;
        return r ? t + r : t
    }
}, function (e, t) {
    e.exports = require("react")
}]);